<template>
  <div class="Kanit mx-2" v-if="data">
    <div v-if="data && data.length">
      <div class="my-3" v-for="(item, k) in data" :key="k">
        <v-card @click="showProducts(k)">
          <v-card-text class="pb-0">
            <div style="font-size: small; display: flex; justify-content: space-between">
              <div>{{ item.order_number }}</div>
              <!-- <div v-if="title == 'รอการชำระเงิน'" style="float: right">
              <v-btn @click.stop="goToPayment(item)" small color="primary">ชำระเงิน</v-btn>
            </div> -->
              <div v-if="item.paiddate">
                {{ moment(item.paiddate).format('DD/MM/YYYY HH:mm') }}
              </div>
            </div>
            <span>ชื่อ: {{ item.dealer_name }}</span>
            <div>
              <em class="fab fa-line" />

              {{ item.dealer_linename }}
            </div>
            <v-layout>
              <v-flex xm6>
                <div>การขนส่ง:</div>
                <div style="font-weight: bold">
                  <span v-if="item.shippingtype == 'scgexpress'">
                    <img
                      style="height: 50%; width: 64px"
                      src="/static/img/assets/toa/scgexpress.png"
                    />
                  </span>
                  <span v-else>ร้านค้าส่งเอง</span>
                </div>
              </v-flex>
              <v-flex xm6>
                <div>ค่าส่ง: {{ item.productdetail.shippingcharge }}</div>
                <div>รวมทั้งหมด: {{ item.productdetail.total }}</div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <div v-if="k === activeshow" class="px-2 pt-2" style="background-color: whitesmoke">
            <v-card
              outline
              class="mb-2 pa-1 Kanit"
              outlined
              v-for="(product, index) in item.productdetail.productlist"
              :key="index"
            >
              <v-layout
                @click.stop="
                  () => {
                    return false
                  }
                "
              >
                <v-flex class="py-1" xm5>
                  <div v-if="product.image">
                    <v-img
                      lazy-src="../assets/whiteimg.jpg"
                      :src="product.image"
                      @error="() => (product.image = null)"
                    >
                      <template v-slot:placeholder>
                        <v-layout class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="grey"></v-progress-circular>
                        </v-layout>
                      </template>
                    </v-img>
                  </div>
                  <div v-else>
                    <div
                      style="
                        height: 100px;
                        width: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <v-icon>mdi-block-helper</v-icon>
                    </div>
                  </div>
                </v-flex>
                <v-flex class="pl-0 py-1" xm7>
                  <div style="font-weight: bold; font-size: 13px">
                    {{ product.sales_text_th }}
                  </div>
                  <div style="padding-right: 13px; font-size: 11px">
                    ขนาด: {{ product.size }} สี: {{ product.shade }}
                  </div>
                  <div style="padding-right: 13px; font-weight: bold; font-size: 13px">
                    จำนวน: {{ product.quantity }}
                  </div>
                  <div style="font-size: 35px"></div>
                  <div v-if="product.price" style="color: red">
                    ราคารวม:
                    {{ parseFloat(product.quantity) * parseFloat(product.price) }}
                  </div>
                  <div v-else style="color: red">ราคารวม: 0</div>
                </v-flex>
              </v-layout>
            </v-card>
          </div>
          <div class="text-center">
            <v-icon v-if="k === activeshow" color="primary">mdi-chevron-up</v-icon>
            <v-icon v-else color="primary">mdi-chevron-down</v-icon>
          </div>
        </v-card>
      </div>
    </div>
    <div v-else class="text-center mt-6" style="text-align: center; margin-top: 31px">
      ไม่มีข้อมูล
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    orders: {
      type: Array,
      default: []
    },
    user: {
      default: {}
    },
    title: {
      default: ''
    }
  },
  computed: {
    moment() {
      return moment
    },
    query() {
      return this.$store.state.query
    }
  },
  data() {
    return {
      data: '',
      activeshow: ''
    }
  },
  mounted() {
    this.data = this.orders.map((el) => {
      return { ...el, productdetail: JSON.parse(el.productdetail) }
    })
  },
  methods: {
    goToPayment(item) {
      Object.assign(this.query, {
        refno: item.order_number,
        customeremail: this.user.email,
        productdetail:
          item.productdetail.productlist[0].material +
          ' x ' +
          item.productdetail.productlist[0].quantity +
          '...',
        total: item.productdetail.productlist.length
      })
      this.$nextTick(() => {
        this.query.view = 'PaySolutionGateway'
      })
    },
    showProducts(k) {
      if (k === this.activeshow) {
        this.activeshow = ''
        this.$forceUpdate()
      } else {
        this.activeshow = k
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/ToaOrderList.vue